import { useEffect, useState } from "react";
import axios from "axios";
import { Star } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const TrustBanner = () => {
  const [googleScore, setGoogleScore] = useState("4.8/5");

  useEffect(() => {
    axios.get(`${API}/reviews`).then(({ data }) => {
      if (data.live && data.rating) setGoogleScore(`${data.rating}/5`);
    }).catch(() => {});
  }, []);

  const ratings = [
    { name: "Google", stars: 5, score: googleScore },
    { name: "Product Review", stars: 5, score: "5/5" },
  ];

  return (
    <div className="bg-slate-900" data-testid="trust-banner">
      <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-center gap-x-8 gap-y-2 px-5 py-4 lg:justify-between lg:px-10">
        <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-2">
          {ratings.map((r) => (
            <span key={r.name} className="flex items-center gap-2 text-xs font-medium text-slate-300" data-testid={`rating-${r.name.toLowerCase().replace(/\s/g, "-")}`}>
              <span className="font-semibold text-white">{r.name}</span>
              <span className="flex items-center gap-0.5">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className={`h-3.5 w-3.5 ${i < r.stars ? "fill-amber-400 text-amber-400" : "text-slate-600"}`} />
                ))}
              </span>
              <span className="text-slate-400">({r.score})</span>
            </span>
          ))}
        </div>
        <p className="hidden text-[11px] font-bold uppercase tracking-[0.25em] text-white md:block">Melbourne&rsquo;s #1 Moving Team</p>
      </div>
    </div>
  );
};
